export interface IMetric {
  name: string;
  value: number;
  dimensions?: Record<string, string>;
}

export const DEFAULT_RESOURCE_TYPE = 'Unknown';
export const DEFAULT_RESOURCE_IDENTIFIER = 'N/A';
export const MICROSOFT_RESOURCE_ID_KEY = 'microsoft.resourceid';
export type ResourceType = typeof DEFAULT_RESOURCE_TYPE | 'Cameras';
export interface IArcMetricDimensions {
  ResourceType: ResourceType;
  ResourceIdentifier: string;
  [key: string]: string;
}

/**
 * User-provided metric dimensions.
 * ResourceType and ResourceIdentifier default to generic values in ArcMetricSubmitter, but callers can override them
 * for resource-specific metrics. microsoft.resourceid is always set by ArcMetricSubmitter.
 */
export interface IUserMetricDimensions {
  ResourceType?: ResourceType;
  ResourceIdentifier?: string;
  [key: string]: string;
}

export interface IArcMetric extends Omit<IMetric, 'dimensions'> {
  dimensions: IArcMetricDimensions;
}
